import React, { useState, useEffect } from 'react';
import api from '../utils/api';

const TermsContent = () => {
    const [contactEmail, setContactEmail] = useState('info@anotherhome.us');
    const lastUpdated = "March 27, 2026";

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const response = await api.get('/content/settings');
                if (response.data.success && response.data.data.contact_email) {
                    setContactEmail(response.data.data.contact_email);
                }
            } catch (error) {
                console.error("Error loading contact email", error);
            }
        };
        fetchSettings();
    }, []);

    // Palette Colors Reference:
    // Dark Text/Headings: #1F2A33
    // Brand Accent: #E84C5B
    // Light Backgrounds: #F6F4F1
    // Border/Muted: #D6D1CB

    return (
        <div className="pt-32 pb-24 px-6 max-w-5xl mx-auto animate-fade-in font-sans text-[#1F2A33]">

            {/* Header */}
            <header className="mb-16 border-b border-[#D6D1CB] pb-10">
                <span className="text-[#E84C5B] font-bold tracking-widest uppercase text-sm mb-4 block">
                    Supplemental Terms & Conditions
                </span>
                <h1 className="text-5xl md:text-6xl font-serif font-bold text-[#1F2A33] mb-6 leading-tight">
                    House Rules & Stay Terms
                </h1>
                <p className="text-lg text-gray-500 italic">
                    Last updated: {lastUpdated}
                </p>
            </header>

            {/* Content */}
            <div className="prose prose-xl prose-slate max-w-none text-[#1F2A33]/80 leading-relaxed">

                {/* Intro */}
                <p className="mb-14 text-xl">
                    This property is subject to applicable laws, regulations, and building or community rules. By booking and occupying the property, the guest agrees to comply with these House Rules & Stay Terms, which form part of the binding agreement governing the reservation and are incorporated by reference into the applicable booking agreement.
                </p>

                {/* 1. Occupancy & Responsibility */}
                <section className="mb-14">
                    <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1F2A33] mb-6">1. OCCUPANCY & RESPONSIBILITY</h2>
                    <p>
                        The primary guest must be at least 18 years of age and is responsible for the conduct and compliance of all occupants and visitors. Maximum occupancy limits must be observed at all times in accordance with applicable law and the reservation details.
                    </p>
                    <p className="mt-4">
                        The number of overnight occupants must match the number approved at the time of booking. Any misrepresentation regarding occupancy may result in additional fees, immediate termination of the stay, or both.
                    </p>
                </section>

                {/* 2. Use of Property */}
                <section className="mb-14">
                    <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1F2A33] mb-6">2. USE OF PROPERTY</h2>
                    <p>
                        The property is provided for temporary residential use only. The property may not be used for events, parties, gatherings, commercial activity, or any unlawful purpose unless expressly authorized in writing.
                    </p>
                    <p className="mt-4">
                        Guests agree to treat the property with reasonable care and respect, including furnishings, fixtures, amenities, and the surrounding neighborhood.
                    </p>
                </section>

                {/* 3. No Parties, No Smoking, No Drugs */}
                <section className="mb-14">
                    <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1F2A33] mb-6">3. NO PARTIES, NO SMOKING, NO DRUGS</h2>
                    <ul className="list-disc pl-6 space-y-3 marker:text-[#E84C5B]">
                        <li>No parties, events, or gatherings of any kind</li>
                        <li>No smoking anywhere on the property</li>
                        <li>No illegal drugs or illegal activity</li>
                        <li>Quiet hours are strictly enforced</li>
                        <li>Loud noise, amplified music, large portable speakers, or sound equipment are prohibited</li>
                    </ul>
                    <div className="bg-[#F6F4F1] p-6 rounded-[1.5rem] border border-[#D6D1CB] mt-8 inline-block">
                        <p className="font-bold text-[#1F2A33] m-0">
                            Violation of these rules may result in immediate termination without refund.
                        </p>
                    </div>
                </section>

                {/* Contact Section (Kept for email state) */}
                <section className="border-t border-[#D6D1CB] pt-14 mt-14">
                    <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1F2A33] mb-8">Contact Us</h2>
                    <p className="mb-6 text-xl">
                        If you have any questions about these rules or your stay, please contact us at:
                    </p>
                    <div className="bg-[#F6F4F1] p-8 md:p-10 rounded-[2rem] inline-block w-full md:w-auto min-w-[350px] border border-[#D6D1CB]">
                        <p className="font-bold text-2xl mb-2 font-serif text-[#1F2A33]">Another Home</p>
                        <p className="text-gray-500 mb-6 text-sm uppercase tracking-wider">Property Support</p>
                        <a href={`mailto:${contactEmail}`} className="text-[#E84C5B] font-bold text-2xl hover:text-[#1F2A33] transition-colors flex items-center gap-2">
                            {contactEmail}
                        </a>
                    </div>
                </section>

            </div>
        </div>
    );
};

export default TermsContent;